import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './services/authguard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: "p/home",
    pathMatch: "full"
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'money',
    loadChildren: () => import('./pages/money/money.module').then(m => m.MoneyPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'products',
    loadChildren: () => import('./pages/products/products.module').then(m => m.ProductsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'recipes',
    loadChildren: () => import('./pages/recipes/recipes.module').then(m => m.RecipesPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'treeitems',
    loadChildren: () => import('./pages/treeitems/treeitems.module').then(m => m.TreeItemsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'users',
    loadChildren: () => import('./pages/users/users.module').then(m => m.UsersPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfilePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'groups',
    loadChildren: () => import('./pages/groups/groups.module').then(m => m.GroupsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'roleGroups',
    loadChildren: () => import('./pages/roleGroups/roleGroups.module').then(m => m.RoleGroupsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'news',
    loadChildren: () => import('./pages/news/news.module').then(m => m.NewsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'work',
    loadChildren: () => import('./pages/work/work.module').then(m => m.WorkPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'healthmonitor',
    loadChildren: () => import('./pages/healthmonitor/healthmonitor.module').then(m => m.HealthMonitorPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'pages',
    loadChildren: () => import('./pages/pages/pages.module').then(m => m.PagesPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'p',
    loadChildren: () => import('./pages/content2/content2.module').then(m => m.ContentPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'sport',
    loadChildren: () => import('./pages/sport/sport.module').then(m => m.SportPageModule),
    canActivate: [AuthGuard]
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
